import { createFileRoute } from '@tanstack/react-router'

import ThresholdsSection from 'pages/Settings/ThresholdsSection'

export const Route = createFileRoute('/_auth/settings/thresholds')({
  component: ThresholdsSection,
})
